import { zodResolver } from "@hookform/resolvers/zod";
import * as Sentry from "@sentry/react-native";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
export function useFormWrapper(options) {
    const { schema, defaultValues, mode = "onSubmit", reValidateMode = "onChange", rethrowSubmitError = false, } = options;
    const form = useForm({
        resolver: zodResolver(schema),
        defaultValues: defaultValues,
        mode,
        reValidateMode,
    });
    const { handleSubmit, reset, clearErrors, formState } = form;
    const submit = useCallback(async (onValid, onInvalid) => {
        return handleSubmit(async (values) => {
            try {
                await onValid({ values, reset });
            }
            catch (e) {
                Sentry.captureException(e);
                console.error("Form submission failed:", e);
                if (rethrowSubmitError) {
                    throw e;
                }
            }
        }, (errors) => {
            if (onInvalid) {
                onInvalid(errors);
            }
        })();
    }, [handleSubmit, reset, rethrowSubmitError]);
    const resetForm = useCallback((next) => {
        clearErrors();
        reset(next);
    }, [clearErrors, reset]);
    useEffect(() => {
        if (formState.isSubmitSuccessful)
            resetForm();
    }, [formState.isSubmitSuccessful, resetForm]);
    // Automatically clear root errors when any field changes
    useEffect(() => {
        const subscription = form.watch((_values, { name }) => {
            if (name && name !== "root" && form.formState.errors.root) {
                form.clearErrors("root");
            }
        });
        return () => subscription.unsubscribe();
    }, [form]);
    const stableForm = form;
    stableForm.submit = submit;
    stableForm.resetForm = resetForm;
    return stableForm;
}
//# sourceMappingURL=useFormWrapper.js.map